export const distinctBy = <T, K>(
    arr: T[],
    keySelector: (item: T) => K
): T[] => {
    if (arr.length < 1) {
        return [];
    }

    const seen = new Map<K, T>();

    arr.forEach((item) => {
        const key = keySelector(item);

        if (seen.has(key)) {
            return;
        }

        seen.set(key, item);
    });

    return Array.from(seen.values());
};
